export enum Roles {
  Owner = 1,
  Manager = 2,
  User = 3,
  Viewer = 7,
  Financier = 8,
  TestManager = 9,
  Admin = 5
}